import {apolloClient} from 'shared/apollo'
import queryCurrentWorkspace from 'shared/graphql/queryCurrentWorkspace.gql'
import {api} from 'shared/plugins/api'
import {useStore} from 'shared/stores/store'

export default async function updateWorkspace(updatedProperties) {
	if (!updatedProperties) return

	const store = useStore()
	const id = store.workspace.id

	const updatedWorkspace = await api.patch(`/workspace/${id}`, updatedProperties)

	// update Apollo GQL cache with actual data after successs
	const cache = apolloClient.cache
	const originalCacheData = cache.readQuery({query: queryCurrentWorkspace, variables: {id}})
	if (!originalCacheData?.currentWorkspace) return
	const data = JSON.parse(JSON.stringify(originalCacheData))
	data.currentWorkspace = {
		...data.currentWorkspace,
		...updatedWorkspace,
	}
	cache.writeQuery({query: queryCurrentWorkspace, variables: {id}, data})
}
